<div mat-dialog-title>{{dialogTitle}}
  <button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear" >clear</i></button>
</div>

<mat-dialog-content>
  <div class="irb-breadcrumb" style="margin-bottom: 20px;width:805px;">
    @for (step of trainStepsTitles; track step; let i = $index) {
      <div [class]="{'irb-active-crumb':currentStepId === i}" [style.width]="'402px'">
        {{ i + 1 }}. {{ step }}
      </div>
    }
  </div>

  @if (currentStepId === 0) {
    <div>
      @if (loadPortfolio && !loadPortfolioError) {
        <div class="block">
          <div class="bold">Selected Portfolio</div>
          <div class="block fontSize12">This portfolio will be sent to FinMason.</div>
          <table class="tblPortfolio">
            <tr>
              <th>Portfolio Name</th>
              <th>Value</th>
              <th>Accounts</th>
              <th>Model</th>
            </tr>
            @for (portfolio of finalPortfolio; track portfolio) {
              <tr>
                <td tooltip [tooltipTitle]="portfolio.portfolioName" [tooltipRequiresTruncation]="true" [tooltipVerticalOffset]="6">{{portfolio.portfolioName}}</td>
                <td >
                  @if (portfolio.totalPortfolioValue < 0) {
                    <span style="color:#D30014">(${{(portfolio.totalPortfolioValue | number:"1.0-0").replace("-", "")}})</span>
                  }
                  @if (portfolio.totalPortfolioValue >= 0) {
                    <span>${{(portfolio.totalPortfolioValue | number:"1.0-0")}}</span>
                  }
                </td>
                <td>{{portfolio.acctQty}}</td>
                <td tooltip [tooltipTitle]="portfolio.securityModelName" [tooltipRequiresTruncation]="true" [tooltipVerticalOffset]="6">{{portfolio.securityModelName}}</td>
              </tr>
            }
          </table>
          <div class="fontSize12">Individual bonds, options and short-positions will be excluded from FinMason analysis.</div>
        </div>
      }
      @if (loadPortfolio && loadPortfolioError) {
        <div class="block">
          <div class="bold">Portfolio Ineligible for Analysis</div>
          @if (loadPortfolioError === 'no values' || loadPortfolioError === 'options_fi_bonds') {
            <div>
              @if (loadPortfolioError === 'no values') {
                <div class="block fontSize12">A portfolio must have a positive market value for FinMason analysis. Cancel and select a different portfolio.</div>
              }
              @if (loadPortfolioError === 'options_fi_bonds') {
                <div class="block fontSize12">This portfolio contains only individual bonds, short positions, and/or options, which cannot be analyzed by FinMason. Cancel and select a different portfolio.</div>
              }
              <table class="tblPortfolioError">
                <tr>
                  <th></th>
                  <th>Portfolio Name</th>
                  <th>Value</th>
                  <th>Accounts</th>
                  <th>Model</th>
                </tr>
                @for (portfolio of finalPortfolio; track portfolio) {
                  <tr>
                    <td><span class="error-icon"></span></td>
                    <td tooltip [tooltipTitle]="portfolio.portfolioName" [tooltipRequiresTruncation]="true" [tooltipVerticalOffset]="6">{{portfolio.portfolioName}}</td>
                    <td >
                      @if (portfolio.totalPortfolioValue < 0) {
                        <span style="color:#D30014">(${{(portfolio.totalPortfolioValue | number:"1.0-0").replace("-", "")}})</span>
                      }
                      @if (portfolio.totalPortfolioValue >= 0) {
                        <span>${{(portfolio.totalPortfolioValue | number:"1.0-0")}}</span>
                      }
                    </td>
                    <td>{{portfolio.acctQty}}</td>
                    <td tooltip [tooltipTitle]="portfolio.securityModelName" [tooltipRequiresTruncation]="true" [tooltipVerticalOffset]="6">{{portfolio.securityModelName}}</td>
                  </tr>
                }
              </table>
            </div>
          }
          @if (loadPortfolioError !== 'no values' && loadPortfolioError !== 'options_fi_bonds') {
            <div>
              <div class="block fontSize12">FinMason doesn't recognize securities in the selected portfolio. The securities may be non-marketable or unavailable. Cancel and select a new portfolio.</div>
              <table class="tblPortfolioSecError">
                <tr>
                  <th></th>
                  <th>Portfolio Name</th>
                  <th>Value</th>
                  <th>Unrecognized securities</th>
                </tr>
                @for (portfolio of finalPortfolio; track portfolio) {
                  <tr>
                    <td><span class="error-icon"></span></td>
                    <td tooltip [tooltipTitle]="portfolio.portfolioName" [tooltipRequiresTruncation]="true" [tooltipVerticalOffset]="6">{{portfolio.portfolioName}}</td>
                    <td >
                      @if (portfolio.totalPortfolioValue < 0) {
                        <span style="color:#D30014">(${{(portfolio.totalPortfolioValue | number:"1.0-0").replace("-", "")}})</span>
                      }
                      @if (portfolio.totalPortfolioValue >= 0) {
                        <span>${{(portfolio.totalPortfolioValue | number:"1.0-0")}}</span>
                      }
                    </td>
                    <td style="position: relative;" tooltip [tooltipTitle]="this.loadPortfolioError" [tooltipRequiresTruncation]="true" [tooltipVerticalOffset]="6">
                      {{this.loadPortfolioError}}
                      <img src="../../assets/images/copy.png" class="invalid-position-copy-to-clipboard"
                        (click)="copyInvalidSecurities(this.loadPortfolioError)">
                    </td>
                  </tr>
                }
              </table>
            </div>
          }
        </div>
      }
      @if (loadModels || loadMMC) {
        <div class="block">
          @if (finalModels.length && !loadMMCError.length && !loadModelsError.length) {
            <div class="bold">Selected Models</div>
          }
          @if (finalModels.length && !loadMMCError.length && !loadModelsError.length) {
            <div class="block fontSize12">These models will be sent to FinMason.</div>
          }
          @if (finalModels.length && (loadMMCError.length || loadModelsError.length)) {
            <div class="bold">Eligible for Comparison</div>
          }
          @if (finalModels.length && (loadMMCError.length || loadModelsError.length)) {
            <div class="block fontSize12">These models will be sent to FinMason.</div>
          }
          @if (loadModels && finalModels.length) {
            <table class="tblModels">
              <tr>
                <th></th>
                <th>Name</th>
                <th>Description</th>
                <th>Type</th>
              </tr>
              @for (model of finalModels; track model; let i = $index) {
                <tr>
                  <td>
                    @if (finalModels.length > 1) {
                      <div class="btn-action-close-delete" (click)="deleteModel(i)"></div>
                    }
                  </td>
                  <td tooltip [tooltipTitle]="model.name" [tooltipRequiresTruncation]="true" [tooltipVerticalOffset]="6" class="span-mmc-model-name">{{model.name}}</td>
                  <td tooltip [tooltipTitle]="model.description" [tooltipRequiresTruncation]="true" [tooltipVerticalOffset]="6">{{model.description}}</td>
                  <td>{{model.type}}</td>
                </tr>
              }
            </table>
          }
          @if (loadMMC && finalModels.length) {
            <table class="tblMMCModels">
              <tr>
                <th></th>
                <th>Model Name and Manager</th>
                <th>Risk Category</th>
                <th>Asset Type</th>
                <th>Strategist Fee</th>
              </tr>
              @for (model of finalModels; track model; let i = $index) {
                <tr>
                  <td>
                    @if (finalModels.length > 1) {
                      <div class="btn-action-close-delete" (click)="deleteModel(i)"></div>
                    }
                  </td>
                  <td>
                    <span class="span-mmc-model-name">{{model.modelMarketName}}</span>
                    <div class="div-model-provider-name">{{model.modelProviderName}}</div>
                  </td>
                  <td>{{model.riskTolerance.label}}</td>
                  <td>{{model.assetType.label}}</td>
                  <td>{{model.costBPs}} bps</td>
                </tr>
              }
            </table>
          }
          @if (loadMMCError.length || loadModelsError.length) {
            <div [style]="{'padding-top': (finalModels.length ? '20px' : '2px')}">
              <div class="bold">Ineligible for Comparison</div>
              <div class="block fontSize12">FinMason doesn't recognize securities in the following models. The securities may be non-marketable or unavailable.
                @if (!finalModels.length) {
                  <span>Cancel and select new models.</span>
                }</div>
                @if (loadModelsError.length) {
                  <table class="tblModelsErr">
                    <tr>
                      <th></th>
                      <th>Name</th>
                      <th>Unrecognized securities</th>
                    </tr>
                    @for (model of loadModelsError; track model; let i = $index) {
                      <tr>
                        <td><span class="error-icon"></span></td>
                        <td class="error-model-name" tooltip [tooltipTitle]="model.name" [tooltipRequiresTruncation]="true" [tooltipVerticalOffset]="6">{{model.name}}</td>
                        <td class="error-model-secs" tooltip [tooltipTitle]="model.invalid_positions" [tooltipRequiresTruncation]="true" [tooltipVerticalOffset]="6">
                          {{model.invalid_positions}}
                          <img src="../../assets/images/copy.png" class="invalid-position-copy-to-clipboard"
                            (click)="copyInvalidSecurities(model.invalid_positions)">
                        </td>
                      </tr>
                    }
                  </table>
                }
                @if (loadMMCError.length) {
                  <table class="tblModelsErr">
                    <tr>
                      <th></th>
                      <th>Name</th>
                      <th>Unrecognized securities</th>
                    </tr>
                    @for (model of loadMMCError; track model; let i = $index) {
                      <tr>
                        <td><span class="error-icon"></span></td>
                        <td class="error-model-name" tooltip [tooltipTitle]="model.modelMarketName" [tooltipRequiresTruncation]="true" [tooltipVerticalOffset]="6">{{model.modelMarketName}}</td>
                        <td class="error-model-secs" tooltip [tooltipTitle]="model.invalid_positions" [tooltipRequiresTruncation]="true" [tooltipVerticalOffset]="6">
                          {{model.invalid_positions}}
                          <img src="../../assets/images/copy.png" class="invalid-position-copy-to-clipboard"
                            (click)="copyInvalidSecurities(model.invalid_positions)">
                        </td>
                      </tr>
                    }
                  </table>
                }
              </div>
            }
          </div>
        }
        <div style="padding-top: 6px;">
          <irb-expando-link text="What is FinMason?">
            FinMason is a goals-based financial application that enables you to analyze and model your client's portfolio outlook and retirement drawdown.
            Use FinMason to explore investment models of varying risk to help you determine your client's overall risk tolerance. Schwab and FinMason are not affiliated.
            <a target="_blank" [href]="sacAboutFinmasonUrl">Learn more about FinMason.</a>
          </irb-expando-link>
        </div>
      </div>
    }

    @if (currentStepId === 1) {
      <div class="send-to-finmason-disclosure">
        <div style="font-weight: bold; margin-bottom: 5px;">You're Leaving Schwab Advisor Center</div>
        <div style="margin-bottom: 15px;">You are being redirected to a third-party website that is owned and operated by FinMason, Inc. Use of this third-party site is subject to the terms and conditions of the Web Site User Agreement you agreed to upon registration with the Schwab Advisor Center website.</div>
        <div style="margin-bottom: 15px;">
          FinMason, Inc. performance data is provided by Morningstar. Charles Schwab & Co., Inc. (Schwab) is not responsible for the content on this website and does not edit or endorse any of the content. FinMason, Inc. is wholly responsible for the content and features found on their site. Therefore, no information provided on this site should be considered a recommendation or endorsement from Schwab. Schwab does not guarantee that the site is accurate, complete or timely, nor does Schwab make any warranties to you regarding any results from using the third-party.
        </div>
        <div>
          Schwab and FinMason, Inc. are separate, unaffiliated companies. Schwab and FinMason, Inc. are not responsible for each other's opinions, policies, and services. The FinMason Model Impact information, printouts, and any information from the Model Market Center™ (MMC) is intended for investment professional use and viewing only and is not a substitute for appropriate model or other investment due diligence. It may not be distributed to members of the public, nor used in written form as sales literature for public use.  If you are analyzing a MMC model, please see the Performance tooltip located in MMC for details on model metrics and how performance calculations differ between what is displayed on the MMC platform and the FinMason, Inc. application.
        </div>
      </div>
    }

  </mat-dialog-content>

  <mat-dialog-actions>
    @if (currentStepId === 1) {
      <div style="position: absolute;left: 20px;">0225-D47E</div>
    }
    <button [class]="cancelButtonClass" (click)="leftButtonClick()">{{leftButtonTitle}}</button>
    @if (currentStepId === 0 && !hideNextButton) {
      <button class="btn-medium-primary" (click)="nextStep()">{{buttonTitle}}</button>
    }
    @if (currentStepId === 1 && !hideNextButton) {
      <button class="btn-medium-primary" (click)="continueToFinMason()">
        Continue to FinMason
      </button>
    }
  </mat-dialog-actions>
